import React, { useEffect, useState } from "react";
import io from "socket.io-client";
// MOMENT
import moment from "moment";
// ANT DESIGN COMPONENTS
import { Button, Tag, Card } from "antd";
// REDUX
import { useSelector } from "react-redux";
import { usePostEmulatorCommandMutation } from "../../../redux/monitoring/monitoringAPI";
// MONITORING STATE
import { useBankDispatch } from "../socketMessageState/BankMessagesContext";
// AUTHENTICATION
import GETJwtToken from "../../../redux/authentication/authentication";
// INTERFACES
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
import { RootState } from "../../../app/store";
import { logError } from "../../../utils/devLog";

const MonitoringWebSocketConnectionEmulator = ({ serverName }: any) => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_EMULATOR || "";
  const dispatch = useBankDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [newSocketClient, setNewSocketClient] = useState<any>(undefined);
  const [isConnected, setIsConnected] = useState(false);
  const [time, setTime] = useState(moment().format("HH:mm:ss"));
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { showQueueInfo, stopSocketConnection } = useSelector(
    (state: RootState) => state.monitoring,
  );

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [postCommandEmulator] = usePostEmulatorCommandMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onConnect = () => {
    setIsConnected(true);
    const SOCKET = io(SOCKET_URL, {
      path: "/simulator",
      reconnectionDelayMax: 3000,
      reconnectionAttempts: 2,
    });
    setNewSocketClient(SOCKET);
  };

  const onMessageJSON = () => {
    newSocketClient.on("message", (socketMessage: SocketMessageInterface) => {
      try {
        const msg: SocketMessageInterface = socketMessage;
        dispatch({ type: "UPDATE_MESSAGE", payload: msg });
      } catch (err) {
        logError("Invalid socket message", err);
      }
    });
  };

  const onMessageFlatBuffer = () => {
    newSocketClient.on("message", (socketMessage: ArrayBuffer) => {
      try {
        // const msg = parseSocketMessage(socketMessage);
        // dispatch({ type: "UPDATE_MESSAGE", payload: msg });
      } catch (err) {
        logError("❌ Invalid FlatBuffer message", err);
      }
    });
  };

  const onDisconnect = () => {
    setIsConnected(false);
    setNewSocketClient(undefined);
    if (newSocketClient) {
      newSocketClient.disconnect();
    }
  };

  const onResetEmulator = async () => {
    const token = await GETJwtToken();
    const BODY = {
      token,
      body: {
        type: "RESET",
        lift_id: "",
        floor: 0,
        bank_id: "",
        front_rear: "",
      },
      serverId: "",
    };
    postCommandEmulator(BODY);
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  useEffect(() => {
    onConnect();
    const interval = setInterval(() => {
      setTime(moment().tz(userTimeZone).format("HH:mm:ss z"));
    }, 1000);
    return () => {
      onDisconnect();
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (newSocketClient) {
      if (
        process.env.REACT_APP_SERIALIZATION_FORMAT &&
        process.env.REACT_APP_SERIALIZATION_FORMAT === "FLAT_BUFFER"
      ) {
        onMessageFlatBuffer();
      } else {
        onMessageJSON();
      }
    }
  }, [newSocketClient]);

  useEffect(() => {
    if (stopSocketConnection) {
      onDisconnect();
    } else {
      onConnect();
    }
  }, [stopSocketConnection]);

  // ************************************************ */
  // COMPONENT ************************************** */

  return (
    <div>
      {showQueueInfo && (
        <div>
          <Card
            title={serverName}
            style={{ width: 400 }}
            extra={
              <div>
                {!isConnected && (
                  <Button onClick={onConnect} disabled={isConnected}>
                    Connect
                  </Button>
                )}
                {isConnected && (
                  <Button onClick={onDisconnect} disabled={!isConnected}>
                    Disconnect
                  </Button>
                )}
                <Button
                  className="generalStyles__mlFix"
                  onClick={onResetEmulator}
                  disabled={!isConnected}
                >
                  Reset Emulator
                </Button>
              </div>
            }
          >
            <p style={{ marginBottom: "-1px" }}>
              <b className={`${isConnected ? "generalStyles__info" : "generalStyles__warning"}`}>
                Status:
              </b>{" "}
              <b style={{ color: "white" }}>
                {isConnected && <Tag color="green">OPEN</Tag>}
                {!isConnected && <Tag color="red">CLOSED</Tag>}
              </b>
            </p>
            <p style={{ marginBottom: "-1px" }}>
              <b className={`${isConnected ? "generalStyles__info" : "generalStyles__warning"}`}>
                Socket Connection:
              </b>{" "}
              <span>EMULATOR</span>
            </p>
            <p style={{ marginBottom: "-1px" }}>
              <b className={`${isConnected ? "generalStyles__info" : "generalStyles__warning"}`}>
                Watch:
              </b>
              <span>
                {" "}
                {userTimeZone} -{time}
              </span>
            </p>
          </Card>
        </div>
      )}
    </div>
  );
};
export default MonitoringWebSocketConnectionEmulator;
